import { useContext } from 'react';

import { ViewContext } from '../context/ViewContext.tsx';

export const useViewUiState = () => {
  const context = useContext(ViewContext);
  if (context === undefined) {
    throw new Error('useViewUiState must be used within a ViewContextProvider');
  }

  return {
    activePanelSetting: context.activePanelSetting,
    setActivePanelSetting: context.setActivePanelSetting,
    previousPanelSetting: context.previousPanelSetting
  };
};
